import React, { ComponentProps } from 'react';
import { StrictReactNode } from '../../types/StrictReactNode';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import {
  CardListItemSubComponentProps,
  wrapCardListItemSubComponent,
  WrappedCardListItemSubComponent
} from '../CardListItem/cardListItemSubComponent';
import styles from './CardListItemTitleWithSubtitle.module.css';

export type CardListItemTitleWithSubtitleProps = Omit<
  ComponentProps<'div'>,
  'children'
> &
  CardListItemSubComponentProps<{
    children: () => {
      title: StrictReactNode;
      subtitle: StrictReactNode | null;
    };
  }>;

export const CardListItemTitleWithSubtitle: WrappedCardListItemSubComponent<CardListItemTitleWithSubtitleProps> =
  wrapCardListItemSubComponent((props) => {
    const { children, className, ...remainingProps } = prepareProps({
      props,
      filter: ['cardListItemInfo']
    });

    const { title, subtitle } = children();

    return (
      <div
        {...remainingProps}
        className={classes(className, styles.titleWrapper)}
      >
        <div
          className={styles.title}
          data-testid="CardListItemTitleWithSubtitle.Title"
        >
          {title}
        </div>
        <div className={styles.subtitleWrapper}>
          <div
            className={styles.subtitle}
            data-testid="CardListItemTitleWithSubtitle.Subtitle"
          >
            {subtitle}
          </div>
        </div>
      </div>
    );
  });
